import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { message } from 'antd';
import WalkingSpinner from '../../components/spinner/WalkingSpinner';
import oauthApi from '../../services/oauthApi';
import { OAuthProviderType } from '../../data/enums';

const SquareCallback = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [, setLoading] = useState(true);

  const Code = params.get('code');
  const error = params.get('error');
  const CompanyId = params.get('state');

  useEffect(() => {
    if (!Code || error) {
      setLoading(false);
      if (error) message.error('Square OAuth failed: ' + error);
      return;
    }

    const connectSquare = async () => {
      try {
        const query = {
          Code,
          Type: OAuthProviderType.Square,
          CompanyId,
          RedirectUri:
            window.location.origin + '/dashboard/settings/square/callback',
        };
        await oauthApi.callback(query);
        message.success('Square connected successfully!');
        navigate('/dashboard/settings/integrations');
      } catch (err) {
        console.error('OAuth submission failed', err);
        message.error('Failed to connect Square.');
        setLoading(false);
      }
    };

    connectSquare();
  }, [Code, error, CompanyId, navigate]);

  if (!Code) {
    return (
      <div className="flex items-center justify-center h-screen text-red-500">
        Invalid OAuth code
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center h-screen gap-4">
      <WalkingSpinner size={88} />
      <p className="text-sm font-medium text-slate-500 dark:text-slate-400">
        Connecting to Square...
      </p>
    </div>
  );
};

export default SquareCallback;
